// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"droppable__dropzone___3Vryg","overlay":"droppable__overlay___3QZs9","content":"droppable__content___hp-Yb","active":"droppable__active___1plCX"};